export function startTimer() {
    let presentTime = $('.js-countdown').html();
    let timeArray = presentTime.split(/[:]+/);
    let m = timeArray[0];
    let s = checkSecond((timeArray[1] - 1));

    if (s == 59) {
        m = m - 1;
    }

    if (m < 0) {
        return;
    }

    if (m == 0 && s == 0) {
        $('.js-code-not').addClass('_hidden');
        $('.js-code-repeat').removeClass('_hidden');
        $('.js-countdown').html('');
        return;
    }

    $('.js-countdown').html(m + ":" + s);
    setTimeout(startTimer, 1000);
}

function checkSecond(sec) {
    // add zero in front of numbers < 10
    if (sec < 10 && sec >= 0) {
        sec = "0" + sec;
    }

    if (sec < 0) {
        sec = "59";
    }

    return sec;
}